import React, { useEffect, useState, Suspense } from "react";
import PropTypes from "prop-types";
// core components
import Header from "../../components/header/header";
import HeaderBanner from "../../components/banner/banner";
import Footer from "../../components/footer/footer";
// sections for this page
import WeAreVarahiSoft from "../../components/WeAreVarahiSoft/weAreVarahiSoft";

import IndustriesWeSpecialize from "../../components/IndustriesWeSpecialize/IndustriesWeSpecialize";
import ProjectsOngoing from "../../components/ProjectsOngoing/ProjectsOngoing";
import SpecializedTechnologies from "../../components/SpecialisedinTechnologies/SpecialisedinTechnologies";
import TechIndustryQuality from "../../components/TechIndustryQuality/TechIndustryQuality";
// import ClientCount from "../../components/ClientCount/ClientCount";
import CaseStudy from "../../components/CaseStudy/CaseStudy";
import YourIdea from "../../components/YourIdea/YourIdea";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import OurLatestBlogs from "../../components/OurLatestBlogs/OurLatestBlogs";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
// import { clientCounterData } from "../../common";
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import axios from "axios";
import Toasts from "../../components/Toasts/Toasts";
import SuspenseLoader from "../../components/SuspenseLoader";
// import { useLocation } from "react-router-dom";

// import Loadable from "../../components/Loadable"
// const WeAreVarahiSoft = lazy(() =>
//     import("../../components/WeAreVarahiSoft/weAreVarahiSoft")
// );

// const IndustriesWeSpecialize = lazy(() =>
//     import("../../components/IndustriesWeSpecialize/IndustriesWeSpecialize")
// );

// const ProjectsOngoing = lazy(() =>
//     import("../../components/ProjectsOngoing/ProjectsOngoing")
// );

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const HeaderBanner = Loadable(
//     lazy(() => import('../../components/banner/banner'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const WeAreVarahiSoft = Loadable(
//     lazy(() => import('../../components/WeAreVarahiSoft/weAreVarahiSoft'))
// )
// const IndustriesWeSpecialize = Loadable(
//     lazy(() => import('../../components/IndustriesWeSpecialize/IndustriesWeSpecialize'))
// )
// const ProjectsOngoing = Loadable(
//     lazy(() => import('../../components/ProjectsOngoing/ProjectsOngoing'))
// )
// const SpecializedTechnologies = Loadable(
//     lazy(() => import('../../components/SpecialisedinTechnologies/SpecialisedinTechnologies'))
// )
// const TechIndustryQuality = Loadable(
//     lazy(() => import('../../components/TechIndustryQuality/TechIndustryQuality'))
// )
// const ClientCount = Loadable(
//     lazy(() => import('../../components/ClientCount/ClientCount'))
// )
// const CaseStudy = Loadable(
//     lazy(() => import('../../components/CaseStudy/CaseStudy'))
// )
// const YourIdea = Loadable(
//     lazy(() => import('../../components/YourIdea/YourIdea'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )



const HomeScreen = () => {
    // const location = useLocation();
    const [toasts, setToasts] = useState(null)
    const [homePageData, setData] = useState([]);
    const [techIndustryQualityData, setTechIndustryQualityData] = useState([]);
    // const [clientCounterData, setClientCounterData] = useState([]);
    const [FrequentlyAskedQuestionsData, setFrequentlyAskedQuestionsData] = useState({});
    const [aboutPageData, setAboutPageData] = useState({});
    const [geoLocationData, setGeoLocationData] = useState(null);

    // const getAllTechIndustryQualityData = async () => {
    //     try {
    //         const res = await axios.get('/staticDataFiles/techIndustryQualityData.json');
    //         setTechIndustryQualityData(res.data);
    //     } catch (err) {
    //         console.error('Error fetching blogs:', err);
    //     }
    // }
    // const getAllClientCounterData = async () => {
    //     try {
    //         const res = await axios.get('/staticDataFiles/clientCounterData.json');
    //         setClientCounterData(res.data);
    //     } catch (err) {
    //         console.error('Error fetching blogs:', err);
    //     }
    // }
    // const getAllAboutPageData = async () => {
    //     try {
    //         const res = await axios.get('/staticDataFiles/aboutPageData.json');
    //         setAboutPageData(res.data);
    //     } catch (err) {
    //         console.error('Error fetching blogs:', err);
    //     }
    // }
    // const getAllHomePageData = async () => {
    //     try {
    //         const res = await axios.get('/staticDataFiles/homePageData.json');
    //         setData(res.data);
    //     } catch (err) {
    //         console.error('Error fetching blogs:', err);
    //     }
    // }
    // const getAllFrequentlyAskedQuestionsData = async () => {
    //     try {
    //         const res = await axios.get('/staticDataFiles/frequentlyAskedQuestionsData.json');
    //         setFrequentlyAskedQuestionsData(res.data);
    //     } catch (err) {
    //         console.error('Error fetching blogs:', err);
    //     }
    // }

    // useEffect(() => {
    //     getIPGeoLocation()
    //     getAllHomePageData()
    //     getAllAboutPageData()
    //     getAllClientCounterData()
    //     getAllTechIndustryQualityData()
    //     getAllFrequentlyAskedQuestionsData()
    // }, [])
    useEffect(() => {
        // getIPGeoLocation(location.pathname)
        const fetchData = async () => {

            try {

                const [
                    home,
                    about,
                    // client,
                    tech,
                    faq
                ] = await Promise.all([
                    axios.get('/staticDataFiles/homePageData.json'),
                    axios.get('/staticDataFiles/aboutPageData.json'),
                    // axios.get('/staticDataFiles/clientCounterData.json'),
                    axios.get('/staticDataFiles/techIndustryQualityData.json'),
                    axios.get('/staticDataFiles/frequentlyAskedQuestionsData.json')
                ]);

                setData(home.data);
                setAboutPageData(about.data);
                // setClientCounterData(client.data);
                setTechIndustryQualityData(tech.data);
                setFrequentlyAskedQuestionsData(faq.data);

            } catch (err) {
                console.error(err);
            }

        };

        fetchData();

    }, []);

    return (
        <div id="main-wrapper">
            <Header geoLocation={setGeoLocationData} />
            <div className="home-page-wrapper page-wrapper">
                <div className="container-fluid">
                    <HeaderBanner bannerImg={homePageData?.bannerImg} data={homePageData?.headerData} />
                    <Suspense fallback={<SuspenseLoader />}>
                        <WeAreVarahiSoft varahiSoftData={homePageData?.weAreVarahiSoftData} />
                        <IndustriesWeSpecialize industriesWeSpecializeData={homePageData?.industriesWeSpecialize} />
                        <ProjectsOngoing projectsOngoingData={homePageData?.recentProjects} />
                    </Suspense>
                    <SpecializedTechnologies data={aboutPageData?.techIndustry} />
                    <TechIndustryQuality techIndustryQualityData={techIndustryQualityData} />
                    {/* <ClientCount ClientCountData={clientCounterData} /> */}
                    <CaseStudy />
                    <YourIdea yourIdeaData={homePageData?.yourIdea} />
                    <CustomerReviews />
                    <OurLatestBlogs />
                    <div className="home-contact-page">
                        <ContactUsComponent setToasts={setToasts} GeoIpData={geoLocationData} />
                    </div>
                    <FrequentlyAskedQuestions faqData={FrequentlyAskedQuestionsData} />
                </div>
            </div>
            <Footer />
            {toasts && <Toasts toastsList={toasts} />}
        </div>
    );
}

HomeScreen.propTypes = {
    classes: PropTypes.object
};

export default HomeScreen;
